import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";




import facialcat from "../images/category/facialcategory.webp";
import cleanupcat from "../images/category/cleanupcategory.webp";
import detanbleachcat from "../images/category/detanbleachcategory.webp";
import manipedicat from "../images/category/manipedicategory.webp";
import hairbodypolishcat from "../images/category/hairbodypolishcategory.webp";
import packagescat from "../images/category/packagescategory.webp";
import waxandthreadcat from "../images/category/waxandthreadcategory.webp";
import bodyhairmessagecat from "../images/category/bodyhairmessagecategory.webp";



import "./beautycategory.css";

const BeautyCategory = () => {
  const navigate = useNavigate();

  const services = [
    {
      title: "Packages",
      image: packagescat,
      description: "Bridal, Party, Full Beauty Combos",
      link: "/packages",
    },
    {
      title: "Facial",
      image: facialcat,
      description: "Glow, Clean-up, Advanced Facials",
      link: "/category/facialservices",
    },
    {
      title: "Waxing & Threading",
      image: waxandthreadcat,
      description: "Full Body Wax, Eyebrow, Upper lip",
      link: "/category/waxing",
    },
    {
      title: "Clean-Up",
      image: cleanupcat,
      description: "Express, Detan, Skin Clean-up",
      link: "/category/cleanupservices",
    },
    {
      title: "Mani-Pedi",
      image: manipedicat,
      description: "Manicure, Pedicure, Foot Spa",
      link: "/category/manipediservices",
    },
    {
      title: "Detan & Bleach",
      image: detanbleachcat,
      description: "Detan, Bleach",
      link: "/category/detanbleach",
    },
    {
      title: "Body Polish & Hair Spa",
      image: hairbodypolishcat,
      description: "Body Glow, Scrub & Polish",
      link: "/category/hairbodypolish",
    },
    {
      title: "Body & Head Massage",
      image: bodyhairmessagecat,
      description: "Relaxing Body & Head Massage",
      link: "/massage",
    },
  ];

  return (
    <>
      <Header />
      <Navbar />

      {/* HERO */}
      <section className="category-hero text-center">
        <h2>Salon Services</h2>
        <p>Choose your desired beauty service at home</p>
      </section>

      {/* CATEGORY GRID */}
      <section className="container my-5">
        <div className="row g-4">
          {services.map((service, idx) => (
            <div key={idx} className="col-6 col-md-4 col-lg-3">
              <div className="category-card shadow-sm h-100">
                
                <img
                  src={service.image}
                  alt={service.title}
                  className="category-img"
                />

                <div className="p-3 d-flex flex-column">
                  <h5 className="fw-bold">{service.title}</h5>

                  <p className="text-muted small flex-grow-1">
                    {service.description}
                  </p>

                  <button
                    className="btn btn-primary mt-2"
                    onClick={() => navigate(service.link)}
                  >
                    Explore
                  </button>
                </div>

              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default BeautyCategory;